<template>
  <a-config-provider :locale="locale">
    <router-view />
  </a-config-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import dayjs from 'dayjs';
  import 'dayjs/locale/zh-cn';
  dayjs.locale('zh-cn');
  export default {
    name: 'App',
    components: {
      
    },
    data() {
      return {
        locale: zhCN
      }
    }
  }

</script>

<style lang="less">
 .ant-row > .ant-col {
  margin-bottom: 0px !important;
 }
  .container {
      .column {
          width: 100%;
          font-size: 12px;
          padding-left: 10px;
          border-left: 4px solid #1890FF;
          background-color: rgba(24,144,255,0.2);
          margin-bottom: 10px;
          height: 30px;
          line-height: 30px;
      }
  }
  .ant-menu-submenu-popup,.ant-tooltip {
      display: none !important;
  }
  .overhide {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ant-form-item {
    margin-bottom: 12px !important;
  }
  .ant-form-item-label > label {
    font-size: 12px !important;
  }
  .ant-form-item-with-help .ant-form-item-explain {
    font-size: 12px;
  }

  *::-webkit-scrollbar {
    display: none;
  }
  .ant-table td { white-space: nowrap; }


  .ant-card .ant-card-head {
      min-height: auto;
      user-select: none;
      height: 30px !important;
  }
  .ant-card .ant-card-head-title {
    font-size: 14px !important;
    padding: 0 !important;
  }
  .ant-card  .ant-card-head .ant-card-head-wrapper {
      height: 30px !important;
  }
  .ant-card  .ant-card-body {
    padding: 10px 24px;
  }

  .ant-row>.ant-col {
    margin-bottom: 10px;
  }


  .full-modal-drawer {
    .ant-drawer-body{
        margin-bottom: 40px !important;
    }
  }

  /** 适配屏幕小的 设备 */
  @media screen and (max-width: 570px) {
      .status-container {
          display: flex;
          justify-content: space-between;
      }
      .full-modal-drawer {
        .ant-drawer-content-wrapper {
          width:100% !important; 
        }
        .ant-drawer-body{
            margin-bottom: 40px !important;
        }
      }
      .full-modal {
          .ant-modal {
              max-width: 100%;
              top: 0;
              padding-bottom: 0;
              margin: 0;
          }
          .ant-modal-content {
              display: flex;
              flex-direction: column;
              min-height: calc(100vh);
          }
          .ant-modal-body {
              flex: 1;
          }
      }
  }
  
</style>
